import { Icon } from '@vacasa/react-components-lib';
import React, { useState } from 'react';
import * as styled from './Expandable.styled';

interface ExpandableProps {
    title: string;
    children: React.ReactNode;
}

export const Expandable: React.FC<ExpandableProps> = (props) => {
    const [open, setOpen] = useState(false);

    const toggle = () => {
        setOpen(!open);
    };

    return (
        <styled.ComponentDiv>
            <styled.HeaderDiv onClick={toggle}>
                {props.title}
                {open ? (
                    <styled.IconSpan>
                        <Icon.ChevronUp />
                    </styled.IconSpan>
                ) : (
                    <styled.IconSpan>
                        <Icon.ChevronRight />
                    </styled.IconSpan>
                )}
            </styled.HeaderDiv>
            <styled.ExpandableDiv open={open}>{props.children}</styled.ExpandableDiv>
        </styled.ComponentDiv>
    );
};
